import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init() {
    this.label = this.el.querySelector('label')
    this.inputs = this.el.querySelectorAll('input, textarea')
    this.input = this.inputs[0] //eslint-disable-line

    this.label.addEventListener(
      'click',
      () => {
        this.label.style.display = 'none'
        this.input.style.display = 'block'
        this.input.focus()
      },
      true,
    )

    // this.input.addEventListener('focus', () => {
    //   this.input.classList.add('block')
    //   this.label.classList.add('hidden')
    // })

    this.input.addEventListener('blur', () => {
      if (this.input.value === '') {
        this.label.style.removeProperty('display')
        this.input.style.removeProperty('display')
      }
    })
  }
}
